import React from 'react';

export const Archive = ({
  className,
  color = '#6E6B8C',
  height = '20',
  width = '21',
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.93382 18.3333C3.45002 18.3333 3.03572 18.1612 2.6909 17.817C2.34667 17.4722 2.17456 17.0579 2.17456 16.5741V5.5787C2.17456 5.3588 2.21121 5.16088 2.28451 4.98495C2.35782 4.80903 2.45311 4.64043 2.57039 4.47917L3.80188 2.9838C3.91916 2.82253 4.06576 2.70144 4.24169 2.62051C4.41762 2.54017 4.6082 2.5 4.81345 2.5H15.369C15.5743 2.5 15.7648 2.54017 15.9408 2.62051C16.1167 2.70144 16.2633 2.82253 16.3806 2.9838L17.6121 4.47917C17.7293 4.64043 17.8246 4.80903 17.8979 4.98495C17.9712 5.16088 18.0079 5.3588 18.0079 5.5787V16.5741C18.0079 17.0579 17.8358 17.4722 17.4916 17.817C17.1467 18.1612 16.7324 18.3333 16.2486 18.3333H3.93382ZM4.28567 5.13889H15.8968L15.1491 4.25926H5.03336L4.28567 5.13889ZM3.93382 16.5741H16.2486V6.89815H3.93382V16.5741ZM10.0912 15.6944L13.6097 12.1759L12.3783 10.9444L10.9709 12.3519V8.65741H9.2116V12.3519L7.80419 10.9444L6.57271 12.1759L10.0912 15.6944ZM3.93382 16.5741V6.89815V16.5741Z"
      fill={color}
    />
  </svg>
);
